var image_viewer_rtlignore_default = {
  "fontElementMap": "_86BTT",
  "imageContainer": "_9ibYI",
  "expandButton": "GTrbr",
  "expandIcon": "ogyKu",
  "pointer": "k2VLT",
  "imageWrapper": "UonQy",
  "imageRatio": "c9aiU",
  "image": "Epnnj",
  "imageOverlay": "_4KmZJ",
  "imagePreload": "-okoM",
  "imageHighres": "_5wQZS",
  "onlyHighRes": "HqteR",
  "image_loading": "siEYk"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
